import { useContext } from "react"
import { WebBootContext } from "source/publishing/WebBoot"
import { Helmet } from "@dr.pogodin/react-helmet"
import { useCurrentHref } from "./hooks/useCurrentHref"

interface OpenGraphTagsProps {
  title?: string
  imageUrl?: string
  description?: string
}

export default function OpenGraphTags({
  title,
  imageUrl,
  description,
}: OpenGraphTagsProps) {
  const currentHref = useCurrentHref()
  const {
    currentOrganization: {
      attributes: { name: organizationName, avatar_url: organizationAvatarUrl },
    },
  } = useContext(WebBootContext)
  const openGraphTitle = title
    ? `${title} - ${organizationName}`
    : organizationName
  const openGraphDescription =
    description ||
    (title
      ? `${organizationName}'s ${title} on Church Center.`
      : `${organizationName} on Church Center.`)
  const openGraphImage = imageUrl || organizationAvatarUrl

  return (
    <Helmet title={title}>
      {/* Primary Meta Tags */}
      <meta name="description" content={openGraphDescription} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={currentHref} />
      <meta property="og:title" content={openGraphTitle} />
      <meta property="og:description" content={openGraphDescription} />
      <meta property="og:image" content={openGraphImage} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={currentHref} />
      <meta property="twitter:title" content={openGraphTitle} />
      <meta property="twitter:description" content={openGraphDescription} />
      <meta property="twitter:image" content={openGraphImage} />
    </Helmet>
  )
}
